import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import SmoothScroll from "@/components/site/SmoothScroll";
import GrainOverlay from "@/components/site/GrainOverlay";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

import Home from "@/pages/Home";
import LaEscucha from "@/pages/LaEscucha";
import SobreMi from "@/pages/SobreMi";
import Formacion from "@/pages/Formacion";
import Cuaderno from "@/pages/Cuaderno";
import Articulo from "@/pages/Articulo";
import PrimeraEntrevista from "@/pages/PrimeraEntrevista";
import Contacto from "@/pages/Contacto";
import Agenda from "@/pages/Agenda";

function Layout({ children }) {
  return (
    <div className="App relative">
      <GrainOverlay />
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#2A2C29",
              color: "#f9f8f6",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "2px",
            },
          }}
        />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/la-escucha" element={<LaEscucha />} />
            <Route path="/sobre-mi" element={<SobreMi />} />
            <Route path="/formacion" element={<Formacion />} />
            <Route path="/cuaderno" element={<Cuaderno />} />
            <Route path="/cuaderno/:slug" element={<Articulo />} />
            <Route path="/primera-entrevista" element={<PrimeraEntrevista />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/agenda" element={<Agenda />} />
          </Routes>
        </Layout>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
